import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { handleLogout } from "./features/auth/authActions.js";
import { isTokenExpired } from "./helpers/tokenExpiry.js";

export const ExpiredCode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const reduxToken = useSelector((state) => state.user.user.token);
  const rehydrated = useSelector((state) => state._persist?.rehydrated);
  const didLogoutRef = useRef(false);

  const expireSession = useCallback(() => {
    if (didLogoutRef.current) return;
    didLogoutRef.current = true;
    handleLogout(dispatch);
    if (location.pathname !== "/") {
      navigate("/", { replace: true });
    }
  }, [dispatch, location.pathname, navigate]);

  const checkExpiry = useCallback(() => {
    if (!rehydrated) return;

    const revxToken = localStorage.getItem("revxToken");
    const tokenToCheck = reduxToken || revxToken;
    if (!tokenToCheck || tokenToCheck.length <= 1) return;

    if (isTokenExpired(tokenToCheck)) {
      expireSession();
    }
  }, [expireSession, rehydrated, reduxToken]);

  useEffect(() => {
    didLogoutRef.current = false;
    checkExpiry();
  }, [checkExpiry]);

  return null;
};
